export const GET_LIST_TRANS_HISTORY_BY_USER = "GET_LIST_TRANS_HISTORY_BY_USER"
export const GET_LIST_TRANS_HISTORY_BY_USER_ERR = "GET_LIST_TRANS_HISTORY_BY_USER_ERR"

export const CLEAR_LIST_TRANS_HISTORY_BY_USER = "CLEAR_LIST_TRANS_HISTORY_BY_USER"

export const EXPORT_EXCEL_TRANS_HISTORY_BY_USER = "EXPORT_EXCEL_TRANS_HISTORY_BY_USER"
export const EXPORT_EXCEL_TRANS_HISTORY_BY_USER_ERR = "EXPORT_EXCEL_TRANS_HISTORY_BY_USER_ERR"